import { Component, OnInit } from '@angular/core';
import {SessionService} from '../../services/session.service';
import {SavedSession, Session} from '../../types/session';
import {HttpClient} from '@angular/common/http'
import {Router} from '@angular/router';

@Component({
  selector: 'app-start',
  templateUrl: './start.component.html',
  styleUrls: ['./start.component.scss']
})
export class StartComponent implements OnInit {

  games = [{ label: "Bedwars", key: "bw", track: false }, { label: "Heroes", key: "he", track: false },
    { label: "Minecraft Party", key: "mp", track: false }, { label: "Rush", key: "rush", track: false },
    { label: "Stickfight", key: "sf", track: false }];

  session: any = { players: [], stages: [], stage: "selected" }

  constructor(private sessionService: SessionService, private router: Router) { }

  ngOnInit(): void {
  }

  async createSession(input: string) {
    const currenStage: any = { pre: undefined, after: undefined, summary: undefined };
    const activeGames = this.games.filter(game => game.track);
    if (activeGames.length === 0) return console.error("No game selected!");
    currenStage.games = activeGames.map(game => game.key);
    const sessionData: Session = { players: input.split("\n"), stage: "initialized", stages: [currenStage] };
    this.sessionService.activeSession = { data: sessionData };

    sessionData.stages[0] = await this.sessionService.gatherStats(sessionData.stages[0], "pre");
    console.log(sessionData.stages[0])
    this.sessionService.activeSession = { data: sessionData };
    await this.sessionService.saveSession();
    await this.router.navigateByUrl("/collection")
  }

}
